import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialGroupConfidentialityDeedState: Dtos.GroupConfidentialityDeed & IRegistrationFormState = {
    id: null,
    groupId: null,
    group: null,
    name: null,
    location: null,
    dateOfDeed: null,
    dateFullyExecuted: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false
}

export interface IGroupConfidentialityDeedReduxFormState {
    id: IFieldState<number>,
    groupId: IFieldState<number>,
    group: IFieldState<Dtos.Group>,
    name: IFieldState<string>,
    location: IFieldState<string>,
    dateOfDeed: IFieldState<string>,
    dateFullyExecuted: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>
}
